module.exports = __webpack_public_path__ + "static/img/图层 42.b58a3124.png";